"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var OverlayCard = (function (_super) {
    __extends(OverlayCard, _super);
    function OverlayCard() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.close = function () {
            if (_this.props.config.confirmClose) {
                var confirmClose = _this.props.config.confirmClose();
                if (typeof confirmClose !== "boolean") {
                    confirmClose.then(function (result) {
                        if (result) {
                            _this.props.closeOverlayCard();
                        }
                    });
                }
                else {
                    if (confirmClose) {
                        _this.props.closeOverlayCard();
                    }
                }
            }
            else {
                _this.props.closeOverlayCard();
            }
        };
        return _this;
    }
    OverlayCard.prototype.render = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)([
                "overlay-stack-item",
                this.props.config.className,
                { "center-content": this.props.config.centerContent },
            ]) },
            !this.props.config.hideCloseButton && (react_1.default.createElement("div", { className: "close-overlay", onClick: this.close },
                react_1.default.createElement("span", { className: "icon icon-clear" }),
                react_1.default.createElement("span", { className: "text" }, this.props.config.closeLabel || "Close"))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)([
                    "overlay-stack-item-content",
                    { "overlay-stack-item-content-full": this.props.config.fullPage },
                ]) }, this.props.config.content)));
    };
    OverlayCard = __decorate([
        mobx_react_1.observer
    ], OverlayCard);
    return OverlayCard;
}(react_1.default.Component));
exports.default = OverlayCard;
